import { getGlobalContext } from '../globalContext';
export default function applyMiddleware() {
    var middleware = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middleware[_i] = arguments[_i];
    }
    var next = finalDispatch;
    for (var i = middleware.length - 1; i >= 0; i--) {
        next = applyMiddlewareInternal(middleware[i], next);
    }
    getGlobalContext().legacyDispatchWithMiddleware = next;
}
function applyMiddlewareInternal(middleware, next) {
    return middleware.bind(null, next);
}
export function dispatchWithMiddleware(action, actionType, args, actionContext) {
    if (!getGlobalContext().legacyDispatchWithMiddleware) {
        getGlobalContext().legacyDispatchWithMiddleware = finalDispatch;
    }
    getGlobalContext().legacyDispatchWithMiddleware(action, actionType, args, actionContext);
}
function finalDispatch(action, actionType, args, actionContext) {
    return action();
}
